import { Component, Input } from '@angular/core';
import {
  NgxSkeletonLoaderConfig,
  NgxSkeletonLoaderModule,
} from 'ngx-skeleton-loader';


@Component({
    selector: 'lib-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss'],
    imports: [NgxSkeletonLoaderModule]
})
export class SkeletonLoaderComponent {

  public _theme: NgxSkeletonLoaderConfig['theme'] = { 'margin': '0', 'background-color': 'var(--skeleton)', '--skeleton-loader': 'var(--skeleton-foreground)' };
  @Input() public set theme(value: NgxSkeletonLoaderConfig['theme']){
    this._theme = {...this._theme, ...value};
  };
  @Input() public animation: NgxSkeletonLoaderConfig['animation'] = 'progress';
  @Input() public appearance: NgxSkeletonLoaderConfig['appearance'] = 'line';
  @Input() public loadingText: NgxSkeletonLoaderConfig['loadingText'] = '';
  @Input() public count: NgxSkeletonLoaderConfig['count'] = 1;
  /**
   * The skeleton color of the avatar.
   */
  @Input() public set skeletonColor(value: string) {
    this._theme = { ...this._theme, 'background-color': `var(${value})` };
  }
  /**
   * The skeleton color gradient of the avatar.
   */
  @Input() public set skeletonGradient(value: string) {
    this._theme = { ...this._theme, '--skeleton-loader': `var(${value})` };
  }

}
